import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Button,
  Box
} from '@chakra-ui/react';
import { UpdateSettingsApi } from '../../../../apis/UpdateMaintenance.api';
import { SettingsType } from '../Table/MaintenanceSettingsTable';
import { CustomNumberInput } from '../../../atoms/CustomNumberInput';
import {
  BanInputType,
  CustomStringInput
} from '../../../atoms/CustomStringInput';

interface props {
  isOpen: boolean;
  onClose: () => void;
  EditData: SettingsType | null | undefined;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<SettingsType[] | null | undefined>
  >;
}

export const SettingsEditWindow: React.FC<props> = (props) => {
  const { isOpen, onClose, EditData, setMaintenanceDatas } = props;
  const [inputValue, setInputValue] = useState<string | undefined>(
    EditData?.value
  );

  const PostApi = async () => {
    if (EditData !== undefined && EditData?.item_no !== undefined) {
      const response = await UpdateSettingsApi(EditData.item_no, {
        value: inputValue
      });
      if (response.success === false) {
        alert('編集に失敗しました。');
        return;
      }
      setMaintenanceDatas(response.data as SettingsType[]);
      onClose();
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='260px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            初期設定を編集
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4} w='120px'>
                {EditData?.item_name}
              </Text>
              {EditData?.type === 'string' && (
                <CustomStringInput
                  CheckInfo={{
                    Length: EditData.str_length_max,
                    BanInputType: BanInputType.None,
                    Value: EditData.value
                  }}
                  inputValue={inputValue}
                  setValue={setInputValue}
                  PhohibitionCharaCheck={false}
                />
              )}

              {EditData?.type === 'number' && (
                <CustomNumberInput
                  CheckInfo={{
                    ViewInt: EditData.view_int,
                    ViewDigit: EditData.view_digit,
                    Value: EditData.value
                  }}
                  inputValue={inputValue}
                  setValue={setInputValue}
                />
              )}
            </Box>
            <Button mt={10} onClick={() => PostApi()}>
              更新
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
